import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IRole {
  rolId: number;
  nameRol: string;
  especial: number;
}

export interface RolesState {
  list: IRole[];
  isLoaded: boolean;
}

const initialState: RolesState = {
  list: [],
  isLoaded: false,
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setRoles: (state, action: PayloadAction<IRole[]>) => {
      state.list = action.payload;
      state.isLoaded = true;
    },
    clearRoles: (state) => {
      state.list = [];
      state.isLoaded = false;
    },
  },
});

export default rolesSlice.reducer;
export const { setRoles, clearRoles } = rolesSlice.actions;
